import React from "react";
import cx from "classnames";
import styles from "../scss/AppForm.module.scss";
import Icon from "../../common/components/Icon/Icon";

const AFSecure: React.FC = () => {
    return (
        <div className={styles["af-secure-wrapper"]}>
            <Icon
                alt="Secure Icon"
                size="ml"
                className={cx(styles["icon"])}
                id="Secure"
            />
        </div>
    );
};

export default AFSecure;
